/*
 * @Descripttion: 说明
 * @Author: 聂章帅
 * @Date: 2023-08-16 08:53:30
 * @LastEditors: 聂章帅
 * @LastEditTime: 2023-08-17 15:13:08
 */
import request from "@/util/request";

// 获取资产招商列表
export function getTenderList(data) {
  return request({
    method: "post",
    url: "/api/InvestList",
    data: data,
    params: data
  });
}

// 获取资产招商详情
export function InvestListDetail(data) {
  return request({
    method: "post",
    url: "/api/InvestListDetail",
    data: data
  });
}

// 添加资产招商意向
export function feedback(data) {
  return request({
    method: "post",
    url: "/base/feedback",
    data: data,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token")
    }
  });
}
